<template>
  <div class="app-logo">
    <img class="app-logo__bg" src="/img/misc/sunflower.png" alt="Gucci logo bg">

    <strong>
      <img class="app-logo__gucci" src="/assets/svg/gucci-ladybug-logo.svg" alt="Gucci ladybug logo">
    </strong>
  </div>
</template>

<script>
export default {
  name: 'AppLogo',
};
</script>

<style lang="scss" scoped>
.app-logo {
  position: relative;
  width: max-content;

  &__bg {
    position: relative;
    min-width: 150px;
    width: 29vh;
    margin: 0;

    @include mq($until: mobileL) {
      width: 62vw;
    }
  }

  strong {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 35%;

    transform: translate(-50%, -50%);

    img {
      display: block;
      position: relative;
      width: 100%;
    }
  }
}
</style>
